module.exports = __webpack_public_path__ + "img/6_68.a5254fe2.png";